import { useUserStore } from '~/stores/user'

// Route guard for the system-admin area: super users only. Applied per-page via
// `definePageMeta({ middleware: 'require-super-admin' })` on the system-admin
// parent route, so every section inherits it (co-located, composable — the
// route-level access-control pattern the sections are built around).
export default defineNuxtRouteMiddleware(async () => {
  const userStore = useUserStore()
  await userStore.$ensureInitialised()

  // Non-super → 403 (matches the global 06.user-role guard + 05.access), not a
  // silent bounce to home.
  if (!userStore.isSuperUser) {
    return navigateTo('/403')
  }
})
